import React, { useRef, useEffect, useState } from "react";
import { fabric } from "fabric";
import { updateRack } from "../resources/RackResource";

const FabricCanvas = ({ initialBoxData }) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const objectsRef = useRef([]);
  const tooltipRef = useRef(null);
  const saveButtonRef = useRef(null);
  let boxData = initialBoxData;
  const [isTooltipHovered, setIsTooltipHovered] = useState(false);

  useEffect(() => {
    const canvas = new fabric.Canvas(canvasRef.current, {
      width: containerRef.current.offsetWidth,
      height: 650,
      hoverCursor: "pointer",
      selection: false,
      targetFindTolerance: 2,
    });

    canvas.controlsAboveOverlay = true; // To ensure controls are always above the objects

    if (boxData && Array.isArray(boxData)) {
      boxData.forEach((item, index) => {
        // Create box
        const fillColor =
          item.occupancy === 0
            ? "#5a7684"
            : item.occupancy >= 100
            ? "#f02769"
            : "#198fed"; // Change color based on threshold
        const rect = new fabric.Rect({
          left: parseInt(item.x_location),
          top: parseInt(item.y_location), // Adjust top position to give 16px distance between text and box
          fill: fillColor,
          width:
            item.rack_type === null
              ? 80
              : item.rack_type === "landscape"
              ? 80
              : 55,
          height:
            item.rack_type === null
              ? 44
              : item.rack_type === "landscape"
              ? 44
              : 80, // Adjust height to compensate for the text distance
          selectable: true,
          hasControls: false, // Disable controls for individual objects
          hoverCursor: "pointer", // Change cursor when hovering over objects
          boxData: item, // Attach data to the object for reference
        });

        // Create text
        const name = new fabric.Text(item.name, {
          left:
            parseInt(item.x_location) +
            (item.rack_type === null
              ? 80
              : item.rack_type === "landscape"
              ? 80
              : 55) /
              2, // Position text in the center of the box horizontally
          top:
            parseInt(item.y_location) +
            (item.rack_type === null
              ? 14
              : item.rack_type === "landscape"
              ? 14
              : 34), // Position text above the box with a margin of 16px
          fontSize: 14,
          fill: "white",
          selectable: false,
          textAlign: "center", // Align text horizontally center
          originX: "center",
          fontWeight: 700, // Set origin of text to center for positioning
          fontFamily: "Arial, sans-serif", // Set font family to a default value
        });

        // Group rectangle and text together
        const group = new fabric.Group([rect, name], {
          selectable: true, // Allow selection of the group
          hasControls: false, // Disable controls for the group
          hoverCursor: "pointer", // Change cursor when hovering over the group
        });

        // Add mouse hover event listeners to the group
        group.on("mouseover", function (event) {
          // showTooltip(event, item);
        });

        group.on("mouseout", function (event) {
          // hideTooltip();
        });

        // Debugging: Listen for object modification event
        group.on("modified", function (event) {
          // Show the save button
          saveButtonRef.current.style.display = "block";
        });

        canvas.add(group); // Add the group to the canvas

        // Store reference to group object
        objectsRef.current[index] = group;
      });
    }

    const handleResize = () => {
      canvas.setWidth(containerRef.current.offsetWidth);
      canvas.renderAll();
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
      canvas.dispose();
    };
  }, [boxData, isTooltipHovered]);

  const handleTooltipMouseEnter = () => {
    setIsTooltipHovered(true);
  };

  const handleTooltipMouseLeave = () => {
    setIsTooltipHovered(false);
  };

  const handleSaveButtonClick = () => {
    // Open confirmation dialog
    const isConfirmed = window.confirm(
      "Are you sure you want to save the changes?"
    );
    if (isConfirmed) {
      // Collect updated position data from canvas objects
      const updatedBoxData = boxData.map((item, index) => {
        const group = objectsRef.current[index];

        if (group) {
          return {
            id: item.id,
            warehouse_id: item.warehouse_id,
            name: item.name,
            capacity: item.capacity,
            rack_type: item.rack_type,
            x_location: group.left,
            y_location: group.top,
          };
        } else {
          // If the group is not found, return the original item
          return item;
        }
      });

      updatedBoxData.forEach((item, index) => {
        updateRack(
          item.id,
          item.name,
          item.warehouse_id,
          item.capacity,
          item.x_location,
          item.y_location,
          item.rack_type
        )
          .then(() => {
            if (updatedBoxData.length === index + 1) {
              window.location.reload();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }
  };

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "auto",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <canvas
        ref={canvasRef}
        style={{ position: "absolute", left: 0, top: 0, width: "100%" }}
      />
      <div
        ref={tooltipRef}
        style={{
          position: "absolute",
          display: "none",
          backgroundColor: "white",
          padding: "5px",
          border: "1px solid black",
          zIndex: 9999,
        }}
        onMouseEnter={handleTooltipMouseEnter}
        onMouseLeave={handleTooltipMouseLeave}
      ></div>
      <button
        className="btn btn-info ms-auto radius-10"
        ref={saveButtonRef}
        onClick={handleSaveButtonClick}
        style={{
          position: "absolute",
          display: "none",
          top: "10px",
          right: "10px",
          zIndex: 9999,
        }}
      >
        Save
      </button>
    </div>
  );
};

export default FabricCanvas;
